module.exports = __webpack_public_path__ + "img/16581266_L.727573d8.png";